import { render, staticRenderFns } from "./RendJournalResult.vue?vue&type=template&id=680bbc22&"
import script from "./RendJournalResult.vue?vue&type=script&lang=js&"
export * from "./RendJournalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports